module.exports = __webpack_public_path__ + "img/partido-aprista.9225a913.png";